import { useEffect } from 'react';
import { scrollToAnchor as scrollToAnchorWithOffset } from '@src/lib/utils';

let scrollTimeout;
const scrollToAnchorByHash = (hash) => {
    clearTimeout(scrollTimeout);
    if (!hash) return;
    const id = hash.startsWith('#') ? hash.substring(1) : hash;
    scrollTimeout = setTimeout(() => {
        const targetDom = window.document.querySelector(`[name="${id}"]`);
        if (!targetDom) return;
        scrollToAnchorWithOffset(targetDom, {
            behavior: 'smooth',
        });
    }, 300);
};

export default () => {
    useEffect(() => {
        const handleHashChange = () => {
            scrollToAnchorByHash(window.location.hash);
        };
        // Check hash on initial load
        handleHashChange();
        window.addEventListener('hashchange', handleHashChange);
        return () => {
            window.removeEventListener('hashchange', handleHashChange);
            clearTimeout(scrollTimeout);
        }
    }, []);
};

// Export scrollToAnchorByHash function for external use
export { scrollToAnchorByHash };